






















































































































































import { get, clone } from 'lodash';
import axios from 'axios';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoInput from '@/components/Molecules/co-input/CoInput.vue';
import CoThumbnail from '@/components/Molecules/co-thumbnail/CoThumbnail.vue';
import CoTable from '@/components/Molecules/co-table/CoTable.vue';
import CoTippy from '@/components/Atoms/co-tippy/CoTippy.vue';
import CoConfirmation from '@/components/Molecules/co-confirmation/CoConfirmation.vue';

import EventBus from '@/eventBus';
import CoUser from '@/components/Molecules/co-user/CoUser.vue';
import CoPill from '@/components/Atoms/co-pill/CoPill.vue';

export default {
    name: 'AdministratorsList',
    components: {
        CoLink,
        CoTable,
        CoThumbnail,
        CoConfirmation,
        CoTippy,
        CoInput,
        CoButton,
        CoRoundButton,
        CoUser,
        CoPill,
    },
    data() {
        return {
            objects: [],
            fields: [
                {
                    key: 'Name',
                    label: this.$t('labels.name'),
                    sortable: true,
                },
                {
                    key: 'Actions',
                    label: this.$t('labels.actions'),
                },
            ],

            loading: false,

            // create form data
            name: '',
            nameState: null,

            searchInput: '',

            candidates: [],
            // Counters keep the add flow locked until every mutation and refresh has settled.
            adminListRequests: 0,
            adminUpdateRequests: 0,
            adminListRequestID: 0,
            adminListLoaded: false,
        };
    },
    computed: {
        items() {
            if (this.searchInput) {
                return this.objects.filter(
                    (u) =>
                        get(u, 'Profile.Name', '').toLowerCase().includes(this.searchInput.toLowerCase()) ||
                        u.Email.toLowerCase().includes(this.searchInput.toLowerCase()) ||
                        u.Slug.toLowerCase().includes(this.searchInput.toLowerCase()) ||
                        get(u, 'Profile.FirstName', '').toLowerCase().includes(this.searchInput.toLowerCase()) ||
                        get(u, 'Profile.LastName', '').toLowerCase().includes(this.searchInput.toLowerCase())
                );
            }
            return this.objects;
        },
        canIAddAdmins() {
            if (this.$store.state.limits.MaxAdmins && this.$store.state.limits.MaxAdmins <= this.objects.length) {
                return false;
            }
            return true;
        },
        isAdminActionPending() {
            return !this.adminListLoaded || this.adminListRequests > 0 || this.adminUpdateRequests > 0;
        },
        billingAdminID() {
            return this.$store?.state?.space_configuration_admin?.PaymentMethodeCreatedBy || null;
        },
        meID() {
            return this.$store?.state?.me?.ID || null;
        },
    },
    mounted() {
        this.listAdmins();
    },
    methods: {
        get,

        updateLoadingState() {
            this.loading = this.adminListRequests > 0 || this.adminUpdateRequests > 0;
        },

        recordPaywallUpgradeClick() {
            const currentPlan = this.$store?.state?.space?.PlanSlug;
            const route = this.$route || null;
            const location = route?.path || window.location.pathname;
            const fullPath = route?.fullPath || `${window.location.pathname}${window.location.search}`;

            // record event in Intercom for feature usage tracking and targeted messaging
            EventBus.$emit('intercomTrackEvent', {
                eventName: `paywall_cta_click`,
                payload: {
                    feature: 'more_admins',
                },
            });
            // also record a specific event for the triggered feature to allow granular analysis and targeting
            EventBus.$emit('intercomTrackEvent', {
                eventName: `paywall_cta_click_more_admins`,
            });

            axios
                .post('/me/activity/funnel', {
                    funnel: 'paywall',
                    step: 'cta_click',
                    feature_key: 'more_admins',
                    location,
                    full_path: fullPath,
                    parameters: {
                        plan: currentPlan,
                    },
                })
                .then(() => {
                    // timeout to ensure activity is recorded before navigation
                    setTimeout(() => {
                        this.$router.push('/admin/account');
                    }, 200);
                })
                .catch((error) => {
                    this.$router.push('/admin/account');
                    console.error('Failed to record upgrade click activity', error);
                });
        },

        // recordPaywallTrigger logs when a user triggers the paywall by clicking on a
        recordPaywallTrigger() {
            const currentPlan = this.$store?.state?.space?.PlanSlug;
            const route = this.$route || null;
            const location = route?.path || window.location.pathname;
            const fullPath = route?.fullPath || `${window.location.pathname}${window.location.search}`;

            // record event in Intercom for feature usage tracking and targeted messaging
            EventBus.$emit('intercomTrackEvent', {
                eventName: `paywall_shown`,
                payload: {
                    feature: 'more_admins',
                },
            });
            // also record a specific event for the triggered feature to allow granular analysis and targeting
            EventBus.$emit('intercomTrackEvent', {
                eventName: `paywall_shown_more_admins`,
            });

            axios
                .post('/me/activity/funnel', {
                    funnel: 'paywall',
                    step: 'feature_click',
                    feature_key: 'more_admins',
                    location,
                    full_path: fullPath,
                    parameters: {
                        plan: currentPlan,
                    },
                })
                .catch((error) => {
                    console.error('Failed to record paywall trigger activity', error);
                });
        },
        triggerPaywallUpgrade() {
            // Keep the add action clickable so hitting the limit routes through the paywall instead of disabling the CTA.
            EventBus.$emit('PAYWALL', {
                feature: 'more_admins',
            });
        },
        searchUsers(query, source) {
            // search for users
            return new Promise((resolve, reject) => {
                // exit if query is less than 2 characters
                if (!query || query.length < 2) {
                    resolve([]);
                    return;
                }
                // fetch the search results
                axios({
                    method: 'GET',
                    url: `/admin/member/search/${query}`,
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    cancelToken: source ? source.token : null,
                })
                    .then((response) => {
                        const results = get(response, 'data.objects', []);
                        const mapped = results.map((el) => ({
                            label: get(el, 'object.Profile.Name', ''),
                            value: el.object,
                        }));
                        resolve(mapped);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        selectCandidate(user) {
            if (this.isAdminActionPending) {
                return;
            }

            const u = get(user, 'value', null);
            if (!u) {
                return;
            }
            const fu = this.candidates.find((item) => item.ID === u.ID);
            if (fu) {
                return;
            }

            // Keep the pending selection within the subscription quota before submitting admin promotions.
            if (
                this.$store.state.limits.MaxAdmins &&
                this.$store.state.limits.MaxAdmins <= this.objects.length + this.candidates.length
            ) {
                this.triggerPaywallUpgrade();
                return;
            }

            this.candidates.push({
                ID: get(u, 'ID'),
                Name: get(u, 'Profile.Name'),
                Slug: get(u, 'Slug'),
                ImageURL: get(u, 'Profile.ImageURL'),
            });
        },
        removeCandidate(index) {
            this.candidates.splice(index, 1);
        },
        listAdmins() {
            this.adminListRequestID += 1;
            const requestID = this.adminListRequestID;
            this.adminListLoaded = false;
            this.adminListRequests += 1;
            this.updateLoadingState();

            return axios({
                method: 'GET',
                url: '/admin/administrator/list',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (requestID !== this.adminListRequestID) {
                        return;
                    }

                    this.objects = get(response, 'data.Users', []);
                    this.adminListLoaded = true;

                    // if limit reached, show paywall
                    if (
                        this.$store.state.limits.MaxAdmins &&
                        this.$store.state.limits.MaxAdmins <= this.objects.length
                    ) {
                        this.recordPaywallTrigger();
                    }
                })
                .catch((error) => {
                    if (requestID === this.adminListRequestID) {
                        this.adminListLoaded = false;
                    }
                    console.log(error);
                    EventBus.$emit('ERROR', {
                        Message: this.$t('labels.failedGeneric'),
                        Details: error,
                    });
                })
                .finally(() => {
                    this.adminListRequests -= 1;
                    this.updateLoadingState();
                });
        },
        async save() {
            const candidates = this.candidates.map((item) => clone(item));

            const promoted = await Promise.all(candidates.map((item) => this.makeUserAdmin(item)));
            this.candidates = candidates.filter((item, index) => !promoted[index]);
            return this.listAdmins();
        },

        makeUserAdmin(obj) {
            this.adminUpdateRequests += 1;
            this.updateLoadingState();
            const data = JSON.stringify(obj);

            return axios({
                method: 'POST',
                url: '/admin/administrator/',
                data,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(() => {
                    this.name = '';
                    EventBus.$emit('INFO', {
                        Message: this.$t('labels.changessaved'),
                    });
                    return true;
                })
                .catch((error) => {
                    console.log(error);
                    EventBus.$emit('ERROR', {
                        Message: this.$t('labels.failedGeneric'),
                        Details: error,
                    });
                    return false;
                })
                .finally(() => {
                    this.adminUpdateRequests -= 1;
                    this.updateLoadingState();
                });
        },

        removeAdminRights(obj) {
            this.adminUpdateRequests += 1;
            this.updateLoadingState();
            const data = JSON.stringify(obj);

            return axios({
                method: 'DELETE',
                url: '/admin/administrator/',
                data,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(() => {
                    EventBus.$emit('INFO', {
                        Message: this.$t('labels.changessaved'),
                    });
                    return this.listAdmins();
                })
                .catch((error) => {
                    console.log(error);
                    EventBus.$emit('ERROR', {
                        Message: this.$t('labels.failedGeneric'),
                        Details: error,
                    });
                })
                .finally(() => {
                    this.adminUpdateRequests -= 1;
                    this.updateLoadingState();
                });
        },
    },
};
